export default "__VITE_ASSET__C75kcWCp__"